import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

function IconRocket() {
  return <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>;
}

export default function BoostSuccessPage() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  useEffect(() => {
    // Clean up any stale localStorage from the old client-side flow.
    localStorage.removeItem('boost_listing_ids');
    localStorage.removeItem('boost_package_key');
    // Wipe the persisted picker state so the next boost starts clean.
    try {
      sessionStorage.removeItem('boost_selection');
      sessionStorage.removeItem('boost_pkg');
      sessionStorage.removeItem('boost_selection_boost_single');
    } catch (_) {/* ignore */}
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 20, padding: '48px 40px', maxWidth: 460, width: '100%', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <>
          <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'rgba(99,102,241,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', color: '#6366f1' }}>
            <IconRocket />
          </div>
          <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>{t('boostSuccess.success')}</h2>
          <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 28, lineHeight: 1.6 }}>
            {t('boostSuccess.successSub')}
          </p>
          <button onClick={() => navigate('/my-listings')} style={{ width: '100%', padding: '14px', background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: 'white', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: 'pointer', marginBottom: 12 }}>
            {t('boostSuccess.viewMyListings')}
          </button>
          <button onClick={() => navigate('/')} style={{ width: '100%', padding: '12px', background: 'transparent', color: '#6b7280', border: '1px solid #e5e7eb', borderRadius: 10, fontSize: 14, cursor: 'pointer' }}>
            {t('boostSuccess.backHome')}
          </button>
        </>
      </div>
    </div>
  );
}